import {createSelector} from 'reselect';

import {validateDate} from '@stubhub/header-helpers';
import {getEventTime} from '@stubhub/react-event-helper';
import {Controller} from '@stubhub/react-store-provider';

const eventDataSelector = createSelector(
  (state) => state.event,
  (event = {}) => {
    const eventTime = getEventTime(event);
    const eventDate = validateDate(event);
    const {venue = {}, eventDateLocal, eventStructureData: {ticketInfo} = {}} = event;
    const {name: venueName, locality, state, webURI: venueWebURI} = venue;
    const {totalTickets} = ticketInfo || {};

    return {
      eventName: event.name,
      eventTime,
      eventDate,
      eventDateLocal,
      venueName,
      venueWebURI,
      locality,
      state,
      performers: event.performers || [],
      allPerformers: event.allPerformers || [],
      groupings: event.groupings || [],
      totalTickets,
    };
  }
);

export default new Controller({
  namespace: 'eventInfoHeader',
  mapStateToProps: (state = {}) => {
    return {
      ...eventDataSelector(state),
    };
  },
});
